import {
  ADDNEWWALLETFORCUSTOLIST_SUCCESS,
  ADDNEWWALLETFORCUSTOLIST_FAILED,
  RESET_ADDNEWWALLETFORCUSTOLIST,
  LOADING_ADDNEWWALLETFORCUSTOLIST,
  NETWORK_ERROR_ADDNEWWALLETFORCUSTOLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ADDNEWWALLETFORCUSTOLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case ADDNEWWALLETFORCUSTOLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case ADDNEWWALLETFORCUSTOLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_ADDNEWWALLETFORCUSTOLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_ADDNEWWALLETFORCUSTOLIST:
      return (state = initialState);
    default:
      return state;
  }
};
